module.exports = __webpack_public_path__ + "img/game_glotto.31091f9.jpg";